import { Button, Group, Text } from "@vesatogo/grass-core"
import { Warning } from "phosphor-react"
import { useTranslation } from "react-i18next"
import { useGenerateTradeOtpMutation } from "../../../generated/graphql"
import { CardWithFooter } from "../components/CardWithFooter"
import { Note } from "../components/Note"
import { IOTPProps } from "../lib/types"
import { getHashValue } from "../lib/utils"

export function SendOTPCard({ token, setOtpSent }: IOTPProps) {
  const { t } = useTranslation()
  const hashValue = getHashValue(token)
  const [, GenerateTradeOTP] = useGenerateTradeOtpMutation()

  function sendOTP() {
    GenerateTradeOTP({ token }).then(({ data }) => {
      setOtpSent(data?.generate_trade_otp?.status || false)
    })
  }

  return hashValue && hashValue.phone.length === 4 ? (
    <>
      <Note text={t("sensitive.information")} icon={<Warning size={20} />} />
      <CardWithFooter
        footerSection={
          <Group className="flex justify-center">
            <Button variant="solid" className="!bg-gray-700" onClick={sendOTP}>
              {t("send.otp")}
            </Button>
          </Group>
        }
      >
        <Text size="sm" className="mb-2 !text-gray-800 text-center">
          {t("request.opt.text")}
        </Text>
        <Text className="mb-8 text-xl font-medium !text-gray-800 underline underline-offset-4">
          XXXXXX{hashValue.phone}
        </Text>
      </CardWithFooter>
    </>
  ) : (
    <Note text={t("invalid.link")} />
  )
}
